<template>
  <AppHeaderDropdown right no-caret class="mr-1">
    <template slot="header">
        <img src="img/avatars/1.jpg" class="img-avatar" >
        <span class="d-sm-down-none">{{user.username}}</span>
    </template>

    <template slot="dropdown">
      <b-dropdown-header tag="div" class="thin-border">
        <strong>Hi, {{user.username}}</strong>
      </b-dropdown-header>
      <b-dropdown-item @click="linkClick(menu)" class="thin-border" v-for="(menu, idx) in menus" :key="idx">{{menu.title}}</b-dropdown-item>
      <b-dropdown-item @click="signout">Sign Out</b-dropdown-item>
      <!-- <div class="locale-changer">
        <b-select v-model="$i18n.locale">
          <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ lang }}
          </option>
        </b-select>
      </div> -->
    </template>
  </AppHeaderDropdown>
</template>

<style lang="scss" scoped>
.thin-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}
.dropdown-item {
  padding: 8px 20px;
  color: #73818f;
}
</style>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import auth from "../apis/auth.js";

export default {
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      menus: [],
      user: {
        username: "invalid",
        email: "invalid@mail.com"
      },
      langs: ['id', 'en'] 
    };
  },
  created: async function() {
    this.menus = [
      { title: "User Profile", name: "loan.profile" }
    ];
    this.user = await auth.me();
  },
  methods: {
    myapp() {
      this.$emit("myapp");
    },    
    linkClick(menu) {
      if (menu.name) this.$router.push({ name: menu.name });
    },
    signout() {
      localStorage.clear();
      this.$router.push({name:'page.login'});
    }
  }
};
</script>
